import type { FeatureFlags } from '@/types/featureFlags.ts';
import { zClient } from '@/services/zafClient.ts';

const featureFlags: FeatureFlags = {};

const loadFeatureFlags = async (flags?: Partial<FeatureFlags>) => {
  clearAllFeatureFlags();

  let _featureFlags: FeatureFlags | undefined = undefined;
  if (flags) {
    _featureFlags = flags;
  }
  if (!_featureFlags && zClient) {
    const metadata = await zClient.metadata();
    _featureFlags = metadata.settings;
  }

  Object.assign(featureFlags, _featureFlags);
};

const clearAllFeatureFlags = () => {
  (Object.keys(featureFlags) as Array<keyof FeatureFlags>).forEach((k) => delete featureFlags[k]);
};

export { loadFeatureFlags, featureFlags };
